module.exports = __webpack_public_path__ + "img/Home_Tablet_06.a6ed28c5.jpg";